const salesforceFieldmap = {
    firstName: '00N2o000009CT4m',
    lastName: '00N2o000009CT4r',
    birthdate: '00NOj00000GzfoD',
    pronouns: '00NOj000000icOA',
    email: 'email',
    phone: 'phone',
    nationality: '00N9J000000QEZE',
    residency: '00NOj000000igEr',
    positions: '00N9J000000QEav',
    startDate: '00N9J000000QEa2',
    moreInfoDate: '00N9J000000QEa7',
    motivation: '00N2o000009CUG0',
    english: '00NOj000000sMEr',
    italian: '00NOj000000sMGT',
    arabic: '00NOj000000sMLJ',
    french: '00NOj000000sMI5',
    additionalLanguages: '00N9J000000QEZY',
    basicSafety: '00N9J000000QEZO',
    medicalCertificate: '00N9J000000QEZJ', 
    rhibLicense: '00N2o000009CSQw',
    additionalCertificates: '00N9J000000QEZx',
    relevantSkills: '00NOj000000igl7',
    otherRelevantSkills: '00NOj000002K4MT',
    medicalBackground: '00NOj000000igRl',
    dataprotection: '00N9J000000QEZs',
    orgid: 'orgid',
    retURL: 'retURL',
    '00NOj0000026b5N': '00NOj0000026b5N',
}

export default salesforceFieldmap